import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceiptBillLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Receipt bill",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5461 14.1973C15.5461 14.6113 15.2102 14.9473 14.7961 14.9473H9.13892C8.72486 14.9473 8.38892 14.6113 8.38892 14.1973C8.38892 13.7832 8.72486 13.4473 9.13892 13.4473H14.7961C15.0774 13.4473 15.3225 13.6016 15.4509 13.8301C15.5115 13.9395 15.5461 14.0645 15.5461 14.1973Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5461 9.80273C15.5461 10.2168 15.2102 10.5527 14.7961 10.5527H9.13892C8.72486 10.5527 8.38892 10.2168 8.38892 9.80273C8.38892 9.38867 8.72486 9.05273 9.13892 9.05273H14.7961C14.9666 9.05273 15.1238 9.10938 15.2498 9.20508C15.4299 9.3418 15.5461 9.55859 15.5461 9.80273Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.5842 20.5781C16.322 20.4531 16.0193 20.4434 15.7483 20.5547L13.6023 21.4297C12.5549 21.8574 11.3821 21.8574 10.3352 21.4297L8.19214 20.5547C7.92212 20.4434 7.61792 20.4531 7.3562 20.5781L6.59595 20.9434C5.29907 21.5645 3.7981 20.6172 3.80005 19.1797L3.8103 6.92578C3.8103 5.57812 4.18628 4.39258 4.98999 3.53906C5.80103 2.67969 6.95825 2.25 8.32593 2.25H15.6252C16.9959 2.25 18.1501 2.67969 18.9539 3.54297C19.7522 4.39844 20.1179 5.58203 20.1179 6.92383L20.136 19.1777C20.137 20.6152 18.637 21.5625 17.3391 20.9414L16.5852 20.5801L16.5842 20.5781ZM5.948 19.5898L6.70825 19.2266C7.35327 18.918 8.0979 18.8945 8.76001 19.166L10.9021 20.041C11.2522 20.1836 11.6238 20.2539 11.9954 20.25C12.3489 20.248 12.7019 20.1777 13.0349 20.041L15.1819 19.166C15.843 18.8945 16.5891 18.916 17.2332 19.2266L17.9871 19.5879C18.2878 19.7324 18.636 19.5137 18.636 19.1777L18.6179 6.92578C18.6179 5.84375 18.325 5.06641 17.8572 4.56445C17.3972 4.07227 16.679 3.75 15.6252 3.75H8.32593C7.27612 3.75 6.55005 4.07227 6.08228 4.56836C5.60816 5.07031 5.3103 5.84766 5.3103 6.92578L5.30005 19.1797C5.30005 19.5137 5.6482 19.7324 5.948 19.5898Z",
			fill: "currentColor"
		})
	]
});
export default SvgReceiptBillLine;
